import { HttpService } from "../http/HttpService";
import { AbstractAdminEntityService } from "./AbstractAdminEntityService";
import { CashbackConfigStatus, CashbackConfigV2, CashbackConfigV2ListResponse, CashbackFrequencyV2, CashbackTypeV2 } from "../http/protocol";

export interface CashbackConfigV2ListRequest {
  status?: CashbackConfigStatus;
  includeArchived?: boolean;
  type?: CashbackTypeV2;
  frequency?: CashbackFrequencyV2;
  limit?: number;
  offset?: number;
  orderBy?: string;
  ascending?: boolean;
}

export class CashbackConfigV2Service extends AbstractAdminEntityService<CashbackConfigV2, CashbackConfigV2ListResponse> {
  constructor(http: HttpService) {
    super("/cashback/v2/config", http);
  }

  list<T extends CashbackConfigV2ListRequest>(listRequest: T): Promise<CashbackConfigV2ListResponse> {
    const params = new URLSearchParams();
    if (listRequest.status) {
      params.set("status", listRequest.status);
    }
    params.set("includeArchived", String(listRequest.includeArchived ?? false));
    if (listRequest.type) {
      params.set("type", listRequest.type);
    }
    if (listRequest.frequency) {
      params.set("frequency", listRequest.frequency);
    }
    params.set("limit", String(listRequest.limit ?? 20));
    params.set("offset", String(listRequest.offset ?? 0));
    params.set("orderBy", listRequest.orderBy ?? "id");
    params.set("ascending", String(listRequest.ascending ?? true));
    return this.http.get(`${this.entityPath}?${params.toString()}`);
  }

  save(entity: CashbackConfigV2): Promise<CashbackConfigV2> {
    if (entity.id != null) {
      return this.http.put(`${this.entityPath}/${entity.id}`, JSON.stringify(entity));
    }
    return this.http.post(this.entityPath, JSON.stringify(entity));
  }
}
